module.exports = __webpack_public_path__ + "static/media/delivery_icon.448ee760.svg";